export default __webpack_public_path__ + "static/media/facebook.e3b5b8e3.svg";